import { USER_MANAGEMENT_API_ENDPOINTS } from '@/constants';
import { api } from '@/services';
import { ApiResponse, PagedResponse } from '@/types';

import {
  IAuditLog,
  IAuditLogSearchingPayload,
  IUser,
  IUserSearchingPayload,
} from '@/features/user-management/user-management-list/interfaces';

export const UserManagementListService = {
  userSearch: async (payload: IUserSearchingPayload): Promise<PagedResponse<IUser>> => {
    const response = await api.post<ApiResponse<PagedResponse<IUser>>>(
      USER_MANAGEMENT_API_ENDPOINTS.USER_SEARCH,
      payload,
    );
    return response.data.data;
  },

  auditLogSearch: async (payload: IAuditLogSearchingPayload): Promise<PagedResponse<IAuditLog>> => {
    const response = await api.post<ApiResponse<PagedResponse<IAuditLog>>>(
      USER_MANAGEMENT_API_ENDPOINTS.AUDIT_LOG_SEARCH,
      payload,
    );
    return response.data.data;
  },

  deactivateUser: async (userId: string): Promise<ApiResponse<string>> => {
    const response = await api.patch<ApiResponse<string>>(
      USER_MANAGEMENT_API_ENDPOINTS.DEACTIVATE_USER.replace(':id', userId),
    );
    return response.data;
  },

  reactivateUser: async (userId: string): Promise<ApiResponse<string>> => {
    const response = await api.patch<ApiResponse<string>>(
      USER_MANAGEMENT_API_ENDPOINTS.REACTIVATE_USER.replace(':id', userId),
    );
    return response.data;
  },

  resendInvitation: async (userId: string): Promise<ApiResponse<string>> => {
    const response = await api.post<ApiResponse<string>>(
      USER_MANAGEMENT_API_ENDPOINTS.RESEND_INVITATION.replace(':id', userId),
    );
    return response.data;
  },

  deleteUser: async (userId: string): Promise<ApiResponse<string>> => {
    const response = await api.delete<ApiResponse<string>>(
      USER_MANAGEMENT_API_ENDPOINTS.DELETE_USER.replace(':id', userId),
    );
    return response.data;
  },
};
